import { useEffect, useState, useCallback } from 'react';
import { db } from '../firebase';
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';

export const useProducts = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const qProducts = query(collection(db, 'products'), orderBy('createdAt', 'desc'));
    const unsubProducts = onSnapshot(
      qProducts,
      (snapshot) => {
        const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setProducts(list);
        setLoading(false);
      },
      (err) => { setError(err.message || 'Falha ao carregar produtos'); setLoading(false); }
    );

    const qCategories = query(collection(db, 'categories'), orderBy('title'));
    const unsubCategories = onSnapshot(
      qCategories,
      (snapshot) => {
        const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setCategories(list);
      },
      (err) => setError(err.message || 'Falha ao carregar categorias')
    );

    const qPortfolio = query(collection(db, 'portfolio'), orderBy('createdAt', 'desc'));
    const unsubPortfolio = onSnapshot(
      qPortfolio,
      (snapshot) => {
        const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setPortfolio(list);
      },
      (err) => setError(err.message || 'Falha ao carregar portfólio')
    );

    return () => {
      unsubProducts();
      unsubCategories();
      unsubPortfolio();
    };
  }, []);

  const addProduct = useCallback(async (data) => {
    await addDoc(collection(db, 'products'), {
      active: true,
      ...data,
      createdAt: serverTimestamp(),
    });
  }, []);

  const updateProduct = useCallback(async (id, data) => {
    await updateDoc(doc(db, 'products', id), {
      ...data,
      updatedAt: serverTimestamp(),
    });
  }, []);

  const deleteProduct = useCallback(async (id) => {
    await deleteDoc(doc(db, 'products', id));
  }, []);

  const addCategory = useCallback(async (data) => {
    // data pode conter: { title, slug, subtitle, description, benefits: array<string>, idealFor, image }
    await addDoc(collection(db, 'categories'), {
      active: true,
      subtitle: '',
      description: '',
      benefits: [],
      idealFor: '',
      image: '',
      ...data,
      createdAt: serverTimestamp(),
    });
  }, []);

  const updateCategory = useCallback(async (id, data) => {
    await updateDoc(doc(db, 'categories', id), {
      ...data,
      updatedAt: serverTimestamp(),
    });
  }, []);

  const deleteCategory = useCallback(async (id) => {
    await deleteDoc(doc(db, 'categories', id));
  }, []);

  // Funções do Portfólio
  const addPortfolioProject = useCallback(async (data) => {
    // data pode conter: { title, description, long_description, category, type, materials, gallery: array<string> }
    await addDoc(collection(db, 'portfolio'), {
      active: true,
      ...data,
      createdAt: serverTimestamp(),
    });
  }, []);

  const updatePortfolioProject = useCallback(async (id, data) => {
    await updateDoc(doc(db, 'portfolio', id), {
      ...data,
      updatedAt: serverTimestamp(),
    });
  }, []);

  const deletePortfolioProject = useCallback(async (id) => {
    await deleteDoc(doc(db, 'portfolio', id));
  }, []);

  return {
    products,
    categories,
    portfolio,
    loading,
    error,
    addProduct,
    updateProduct,
    deleteProduct,
    addCategory,
    updateCategory,
    deleteCategory,
    addPortfolioProject,
    updatePortfolioProject,
    deletePortfolioProject,
  };
};
